import type { BatchProcessDto } from "@fp/admin-api-client";
import { formatLocalDate } from "@fp/ui/components/common/local-date-time";
import { getFsmSyncMetadata } from "./fsm-execute-sync-metadata";

export function FsmExecuteSyncWindow({ batch }: { batch: BatchProcessDto }) {
  const metadata = getFsmSyncMetadata(batch);

  if (!metadata) {
    return null;
  }

  return (
    <p className="mt-0.5 truncate text-xs text-tertiary">
      Sync window:{" "}
      {formatLocalDate(metadata.syncWindowStart, "datetimeWithYear")} –{" "}
      {formatLocalDate(metadata.syncWindowEnd, "datetimeWithYear")}
    </p>
  );
}